import {createSlice} from '@reduxjs/toolkit';
import {getMobileOperatingSystem, MobileDevice} from '../../components/functions/Global';

export enum MappingType {
    personPerson = 'person_person',
    personParcel = 'flurstueck_person',
    personLandRegister = 'grundbuch_person',
    landRegisterParcel = 'grundbuch_flurstueck'
}

// Define a type for the slice state
interface GlobalInfoData {
    mobileDevice: MobileDevice
}

// Define the initial state using that type
const initialState: GlobalInfoData = {
    mobileDevice: MobileDevice.Unkown
};

export const globalDataSlice = createSlice({
    name: 'globaldata',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setMobileDevice: (state) => {
            state.mobileDevice = getMobileOperatingSystem();
        },
    },
});

export const {
    setMobileDevice
} = globalDataSlice.actions;

export default globalDataSlice.reducer;
